import React from 'react';
import ReactDOM from 'react-dom';
import { Snackbar } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import '../../styles/action-toast.css';

export default function ActionToast({ open, message, severity = 'success', onClose }) {
    return ReactDOM.createPortal(
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <div className={`action-toast action-toast--${severity}`}>
                <div className="action-toast-icon">
                    {severity === 'success'
                        ? <CheckCircleOutlineIcon fontSize="small" />
                        : <ErrorOutlineIcon fontSize="small" />
                    }
                </div>
                <span className="action-toast-msg">{message}</span>
                {open && (
                    <div
                        className="action-toast-progress"
                        key={`${message}-${open}`}
                        onAnimationEnd={onClose}
                    />
                )}
            </div>
        </Snackbar>,
        document.body
    );
}
